import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import styles from './DetalleSeccion.module.css';
import AreasProfesionales from '../Tutor/tutorcomponentes/AreasProfesionales';
import DirectorioUniversidades from '../Tutor/tutorcomponentes/DirectorioUniversidades';
import FeriasUniversitarias from '../Tutor/tutorcomponentes/FeriasUniversitarias';
import VideosRecorridos from "../Tutor/tutorcomponentes/VideosRecorridos";
import BecasVigentes from '../Tutor/tutorcomponentes/BecasVigentes';
import { FaArrowLeft } from 'react-icons/fa';
import {useAuth} from '../../Auth/AuthContext'; 
import Swal from 'sweetalert2';

const DetalleSeccion = () => {
    const { pa_clave, se_clave } = useParams();
    const navigate = useNavigate();
    const [seccion, setSeccion] = useState(null);
    const [paso, setPaso] = useState(null);
    const [elementosPaso, setElementosPaso] = useState([]);
    const [pasoConTests, setPasoConTests] = useState(null);
    const [loading, setLoading] = useState(true);
    const [progreso, setProgreso] = useState(0);
    const [progresoActualizado, setProgresoActualizado] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [seccionCompletada, setSeccionCompletada] = useState(false);
    
    // Estados para el loading de iframes/videos
    const [iframeLoading, setIframeLoading] = useState(true);
    const [videoLoading, setVideoLoading] = useState(true);
    const [loadingTimeout, setLoadingTimeout] = useState(null);
    
    const {getToken} = useAuth(); 
    const token = getToken(); 
    const componentes = {
        AreasProfesionales,
        DirectorioUniversidades,
        FeriasUniversitarias, 
        VideosRecorridos, 
        BecasVigentes

    };
    const progresoRef = useRef(null);

    const resetearEstados = () => {
        setSeccion(null);
        setPaso(null);
        setElementosPaso([]);
        setPasoConTests(null);
        setLoading(true);
        setProgreso(0);
        setProgresoActualizado(false);
        setMensaje('');
        setSeccionCompletada(false);
        setIframeLoading(true);
        setVideoLoading(true);
        progresoRef.current = null;
        
        // Limpiar timeout si existe
        if (loadingTimeout) {
            clearTimeout(loadingTimeout);
            setLoadingTimeout(null);
        }
    };

    const handleVolverTemas = () => {
        navigate('/temas');
    };

    // useEffect principal que se ejecuta cuando cambian los parámetros
    useEffect(() => {
        resetearEstados();
        // Cargar datos
        const cargarDatos = async () => {
            setLoading(true);
            
            try {
                if (se_clave) {
                    await fetchSeccionDetails();
                    // Solo actualizar progreso una vez por sección
                    if (progresoRef.current !== se_clave) {
                        progresoRef.current = se_clave;
                        await actualizarProgresoSeccion();
                    }
                }
                // Si hay pa_clave, cargar paso y elementos
                if (pa_clave) {
                    await fetchPasoDetails();
                    await fetchElementosPaso();
                    await fetchTest();
                }
            } catch (error) {
                console.error('Error al cargar datos:', error);
            } finally {
                setLoading(false);
            }
        }; 

        cargarDatos();
    }, [pa_clave, se_clave]);

    // Cleanup del timeout cuando el componente se desmonte
    useEffect(() => {
        return () => {
            if (loadingTimeout) {
                clearTimeout(loadingTimeout);
            }
        };
    }, [loadingTimeout]);

    const getUserId = () => {
        if (token) {
            try {
                const payload = JSON.parse(atob(token.split('.')[1]));
                return payload.id;
            } catch (error) {
                console.error('Error al decodificar token:', error);
                return null;
            }
        }
        return null;
    };

    const fetchSeccionDetails = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/seccion/${se_clave}`, {
                headers: { 
                    'Authorization': `Bearer ${token}`,
                }
            });
            const pasoData = await response.json();
            
            if (pasoData && pasoData.length > 0) {
                setSeccion(pasoData[0]);
            } else {
                setSeccion(null);
            }
        } catch (error) {
            console.error('Error al cargar la seccion:', error);
            setSeccion(null);
        }
    };

    const fetchPasoDetails = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/paso/${pa_clave}` , {
                headers: {
                    'Authorization':  `Bearer ${token}`
                }
            });
            const pasoData = await response.json();
            
            if (pasoData && pasoData.length > 0) {
                setPaso(pasoData[0]);
            } else {
                setPaso(null);
            }
        } catch (error) {
            console.error('Error al cargar el paso:', error);
            setPaso(null);
        }
    };

    const fetchElementosPaso = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/paso-elementos/${pa_clave}`, { 
                headers: { 
                        'Authorization':  `Bearer ${token}`
                }
            });
            if (response.ok) {
                const elementosData = await response.json();
                const elementosOrdenados = elementosData.sort((a, b) => a.pael_orden - b.pael_orden);
                setElementosPaso(elementosOrdenados);
            } else {
                setElementosPaso([]);
            }
        } catch (error) {
            console.error('Error al cargar elementos del paso:', error);
            setElementosPaso([]);
        }
    };

    const fetchTest = async () => {
    try {
        // Asegurarnos de obtener el token del localStorage justo antes de la petición
        // NOTA: Revisa si en tu proyecto se guarda como 'token', 'token_sedeq', 'userToken', etc.
        console.log("¿Qué trae token?", token)
        const tokenLocal = localStorage.getItem('token') || token; 

        const testsResponse = await fetch(`${process.env.REACT_APP_API_URL}/pasos/primer-test/${pa_clave}`, {
            headers: { 
                'Authorization': `Bearer ${tokenLocal}` // Usamos la variable local segura
            }
        });

        if (testsResponse.ok) {
            const testsData = await testsResponse.json();
            setPasoConTests(testsData);
        } else if (testsResponse.status === 404) {
            console.warn("El backend devolvió 404 para este test.");
            setPasoConTests(null);
        } else {
            throw new Error('Error al obtener los tests');
        }
    } catch (err) {
        console.error('Error al cargar tests:', err);
        setPasoConTests([]);
    }
};

    const encontrarSiguienteElemento = () => {
        const elementoActual = elementosPaso.find(elemento => 
            elemento.tipo === 'seccion' && elemento.id == se_clave
        );

        if (!elementoActual) return null;

        const indiceActual = elementosPaso.findIndex(elemento => 
            elemento.pael_orden === elementoActual.pael_orden
        );

        // Si hay un siguiente elemento en el array
        if (indiceActual >= 0 && indiceActual < elementosPaso.length - 1) {
            return elementosPaso[indiceActual + 1];
        }

        return null; // No hay más elementos en este paso
    };

    const encontrarElementoAnterior = () => {
        const elementoActual = elementosPaso.find(elemento => 
            elemento.tipo === 'seccion' && elemento.id == se_clave
        );

        if (!elementoActual) return null;

        const indiceActual = elementosPaso.findIndex(elemento => 
            elemento.pael_orden === elementoActual.pael_orden
        );

        if (indiceActual > 0) {
            return elementosPaso[indiceActual - 1];
        }

        return null; // No hay elemento anterior, este es el primero
    };

    const actualizarProgresoSeccion = async () => {
        try {
            const userId = getUserId();

            const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/actualizar-progreso`, {
                method: 'POST',
                headers: {
                    'Authorization':  `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    usuario_id: userId,
                    seccion_id: se_clave,
                    progreso: 100
                })
            });

            const data = await response.json();
            
            if (data.success) {
                setProgreso(100);
                setSeccionCompletada(true);
                return true;
            }
        } catch (error) {
            console.error('Error al actualizar progreso:', error);
        }
        return false;
    };

    const manejarVerPDF = (seccion) => {
        if (seccion.se_archivo) {
            const url = `${process.env.REACT_APP_API_URL}/pasos${seccion.se_ruta_archivo}`;
            window.open(url, '_blank');
        } else {
            alert('Archivo no disponible');
        }
    };

    // Manejo del loading para iframes
    const handleIframeLoad = () => {
        setIframeLoading(false);
        if (loadingTimeout) {
            clearTimeout(loadingTimeout);
            setLoadingTimeout(null);
        }
    };

    // Manejo del loading para videos
    const handleVideoLoad = () => {
        setVideoLoading(false);
        if (loadingTimeout) {
            clearTimeout(loadingTimeout);
            setLoadingTimeout(null);
        }
    };

    // Optimización de URLs
    const optimizeUrl = (originalUrl) => {
        // Google Drive - convertir a formato de visualización directa
        const driveRegex = /(?:https?:\/\/)?(?:www\.)?drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/;
        const driveMatch = originalUrl.match(driveRegex);
        
        if (driveMatch && driveMatch[1]) {
            // Usar el viewer embebido de Google Drive que carga más rápido
            return `https://drive.google.com/file/d/10nOntSPBMCEr3QjzAS3kuSx7b8pT5B3C/preview${driveMatch[1]}/preview`;
        }
        
        // Genially - agregar parámetros para carga más rápida
        if (originalUrl.includes('genially.com')) {
            const separator = originalUrl.includes('?') ? '&' : '?';
            return `${originalUrl}${separator}autoplay=false&controls=true`;
        }
        
        return originalUrl;
    };

    const VideoEmbed = ({ url, className }) => {
        const [isLoading, setIsLoading] = useState(true);

        const getEmbedUrl = (originalUrl) => {
            // Google Drive
            const driveRegex = /(?:https?:\/\/)?(?:www\.)?drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/;
            const driveMatch = originalUrl.match(driveRegex);
            
            if (driveMatch && driveMatch[1]) {
                return `https://drive.google.com/file/d/10nOntSPBMCEr3QjzAS3kuSx7b8pT5B3C/preview${driveMatch[1]}/preview`;
            }
            
            // Canva
            const canvaRegex = /(?:https?:\/\/)?(?:www\.)?canva\.com\/design\/([a-zA-Z0-9_-]+)\/([a-zA-Z0-9_-]+)\/watch/;
            const canvaMatch = originalUrl.match(canvaRegex);
            
            if (canvaMatch && canvaMatch[1] && canvaMatch[2]) {
                const designId = canvaMatch[1];
                const viewId = canvaMatch[2];
                return `https://www.canva.com/design/${designId}/${viewId}/view?embed`;
            }
            
            // YouTube - agregar parámetros de optimización
            const youtubeRegex = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/;
            const youtubeMatch = originalUrl.match(youtubeRegex);
            
            if (youtubeMatch && youtubeMatch[1]) {
                return `https://www.youtube.com/embed/${youtubeMatch[1]}?rel=0&modestbranding=1&enablejsapi=1`;
            }
            
            // Vimeo
            const vimeoRegex = /vimeo\.com\/(\d+)/;
            const vimeoMatch = originalUrl.match(vimeoRegex);
            
            if (vimeoMatch && vimeoMatch[1]) {
                return `https://player.vimeo.com/video/${vimeoMatch[1]}?dnt=1&autopause=0`;
            }
            
            return originalUrl;
        };

        const handleVideoLoaded = () => {
            setIsLoading(false);
        };

        useEffect(() => {
            setIsLoading(true);
            
            // Timeout de seguridad - ocultar loading después de 15 segundos
            const timeoutId = setTimeout(() => {
                setIsLoading(false);
            }, 15000);
            
            return () => clearTimeout(timeoutId);
        }, [url]);

        return (
            <div className={styles.videoContainer}>
                {isLoading && (
                    <div className={styles.loadingOverlay}>
                        <div className={styles.loadingSpinner}></div>
                        <p className={styles.loadingText}>Cargando video...</p>
                    </div>
                )}
                <iframe
                    className={className}
                    src={getEmbedUrl(url)}
                    allow="autoplay; encrypted-media"
                    frameBorder="0"
                    allowFullScreen
                    onLoad={handleVideoLoaded}
                    style={{ opacity: isLoading ? 0 : 1 }}
                />
            </div>
        );
    };

    const handleContinuar = async () => {
        const siguienteElemento = encontrarSiguienteElemento();

        if (siguienteElemento) {
            // Navegar al siguiente elemento del mismo paso
            if (siguienteElemento.tipo === 'seccion') {
                navigate(`/paso/${pa_clave}/seccion/${siguienteElemento.id}`);
            } else if (siguienteElemento.tipo === 'test') {
                navigate(`/paso/${pa_clave}/test/${siguienteElemento.id}`);
            }
        } else {
            // No hay más elementos en este paso, ir al siguiente paso
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/siguiente-paso/${paso.pa_numero}`, {
                    headers: {
                        'Authorization':  `Bearer ${token}`
                    }
                });
                
            if (response.ok) {
                const siguientePasoData = await response.json();
                if (siguientePasoData?.length > 0) {
                    navigate(`/paso/${siguientePasoData[0].pa_clave}`);
                } else {
                    navigate('/temas');
                }
            } else {
                navigate('/temas');
            }
            } catch (error) {
                console.error('Error al buscar siguiente paso:', error);
                Swal.fire({
                    title: 'Error al cargar el siguiente paso', 
                    icon: 'error', 
                    timer: 1000,
                    showConfirmButton: false, 
                    customClass: { 
                        popup: 'popupbonito', 
                    },
                })
            }
        }
    };

    const handleAnterior = () => {
        const elementoAnterior = encontrarElementoAnterior();

        if (elementoAnterior) {
            // Navegar al elemento anterior del mismo paso
            if (elementoAnterior.tipo === 'seccion') {
                navigate(`/paso/${pa_clave}/seccion/${elementoAnterior.id}`);
            } else if (elementoAnterior.tipo === 'test') {
                navigate(`/paso/${pa_clave}/test/${elementoAnterior.id}`);
            }
        } else {
            // No hay elemento anterior, volver al resumen del paso
            navigate(`/paso/${pa_clave}`);
        }
    };

    // Efecto para manejar el timeout de loading de iframe/video
    useEffect(() => {
        if (seccion && (seccion.se_tipo_archivo === 'URL' || seccion.se_tipo_archivo === 'Video')) {
            setIframeLoading(true);
            setVideoLoading(true);
            
            // Timeout de seguridad - ocultar loading después de 10 segundos
            const timeoutId = setTimeout(() => {
                setIframeLoading(false);
                setVideoLoading(false);
            }, 10000);
            
            setLoadingTimeout(timeoutId);
            
            return () => {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
            };
        }
    }, [seccion]);

    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.loadingContent}>
                    <div className={styles.loadingSpinner}></div>
                    <p className={styles.loadingText}>Cargando datos...</p>
                </div>
            </div>
        );
    }

    if (!seccion && se_clave) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.loadingContent}>
                    <p className={styles.loadingText}>No se encontró la sección solicitada :(</p>
                </div>
            </div>
        );
    }

    if (!paso && pa_clave) {
                return (
            <div className={styles.loadingContainer}>
                <div className={styles.loadingContent}>
                    <p className={styles.loadingText}>No se encontró el paso solicitado :(</p>
                </div>
            </div>
        );
    }

    return(
        <div>
            <div className={styles.vistaContainer}>
                <button onClick={handleVolverTemas} className={styles.btnBack}> <FaArrowLeft /> Volver</button>
                <div className={styles.cuerpoContainerSeccion}>
                    <div className={styles.rowContainer}>
                        <div className={styles.rowContainer}>
                            <h2>{seccion.se_nombre}</h2>
                            
                        </div>

                        {/* Mensaje de éxito */}
                        {mensaje && (
                            <div className={styles.mensajeExito}>
                                {mensaje}
                            </div>
                        )}
                    </div>
                    <div className={styles.rowContainer}>
                        <p>{seccion.se_descripcion}</p>
                        
                        {seccion.se_tipo_archivo === 'Ejercicio' &&(
                            <div className={styles.cardFooter}>
                                <div className={styles.botonesContainer}>
                                    <button 
                                        className={styles.verPdfBtn}
                                        onClick={() => manejarVerPDF(seccion)}
                                    >
                                        👁️ Ver PDF
                                    </button>

                                </div>
                            </div>
                        )}
                        {seccion.se_tipo_archivo === 'URL' && (
                            <div className={styles.iframeWrapper}>
                                {iframeLoading && (
                                    <div className={styles.loadingOverlay}>
                                        <div className={styles.loadingSpinner}></div>
                                        <p className={styles.loadingText}>Cargando presentación...</p>
                                    </div>
                                )}
                                <iframe
                                    className={styles.presentacionUrl}
                                    src={optimizeUrl(seccion.se_url)}
                                    allowFullScreen
                                    allow="fullscreen"
                                    allowscriptaccess="always"
                                    onLoad={handleIframeLoad}
                                    style={{ opacity: iframeLoading ? 0 : 1 }}
                                ></iframe>
                            </div>
                        )}
                        {seccion.se_tipo_archivo === 'Componente' && (
                            <div>
                                {
                                    (() => {
                                        const Componente = componentes[seccion.se_url];
                                        return Componente ? <Componente /> : <div>Componente no encontrado</div>
                                    })()
                                }
                            </div>
                        )}
                        {seccion.se_tipo_archivo === 'Video' && (
    <div>
        <VideoEmbed 
            url={seccion.se_url} 
            className={styles.videoUrl} 
        />
       
    </div>
)}
                        {seccion.se_tipo_archivo === 'PDF' && (
                            <div>
                                <iframe
                                    className={styles.presentacionPdf}
                                    src={`${process.env.REACT_APP_API_URL}/pasos${seccion.se_ruta_archivo}#toolbar=0&navpanes=0&scrollbar=0`}
                                ></iframe>
                            </div>
                        )}
                        <div className={styles.navigationButtons}>
                            <a className={`${styles.btn} ${styles.btnVolverSeccion}`}
                            onClick={handleAnterior}>
                                {encontrarElementoAnterior() ? 'Anterior' : 'Regresar'}
                            </a>
                            <a className={`${styles.btn} ${styles.btnContinueSeccion}`}
                            onClick={handleContinuar}>
                                {(() => {
                                    const siguienteElemento = encontrarSiguienteElemento();
                                    if (siguienteElemento) {
                                        return `Siguiente`;
                                    }
                                    return 'Siguiente';
                                })()}
                            </a>
                        </div>
                    </div>
                </div>                
            </div>
        </div>
    );
}

export default DetalleSeccion;